import Backend from "../../../backend";
import { useFetch } from "./../../Utility/hooks";

export function useCharacters(projectId) {
  const queryFunction = async () => {
    if (!projectId) {
      return [];
    }
    return Backend.__getCharacters(projectId);
  };
  return useFetch(queryFunction, []);
}
